<template>
  <div class="mx-auto max-w-[var(--container)] pt-8 lg:py-8 mb-60 lg:mb-0">
    <div v-if="!!service">
      <Commerce-Breadcrumb class="px-6" :items="breadcrumbItems" />
      <div class="mt-6 grid gap-8 lg:grid-cols-[1fr_360px]">
        <div class="min-w-0 lg:pe-0 lg:ps-6">
          <Commerce-Card
            class="md:border-0 md:bg-transparent mx-6 lg:mx-0 px-4 py-5 lg:p-0"
          >
            <div class="flex items-start gap-4">
              <Commerce-ServiceGlyph
                :src="service?.logoUrl"
                :glyph="serviceGlyph"
                size="lg"
              />
              <div>
                <div class="flex items-center gap-2">
                  <h1 class="text-2xl font-bold md:text-3xl">
                    {{ service.name }}
                  </h1>
                </div>
                <p class="text-muted-foreground">
                  {{ service.provider?.name }}
                </p>
              </div>
            </div>
          </Commerce-Card>

          <Commerce-Card
            class="min-w-0 w-full py-4 lg:p-6 mt-6 rounded-none! lg:rounded-[var(--radius-lg)]! border-0 lg:border bg-white"
          >
            <p
              class="text-justify leading-7 text-base whitespace-pre-line"
              v-if="service.short_description"
            >
              {{ service.short_description }}
            </p>

            <h2 class="ms-4 mt-4 lg:ms-0 text-lg font-bold">پلن سرویس</h2>
            <ul
              class="min-w-0 mt-2 flex lg:flex-wrap py-1 px-4 lg:px-0 overflow-x-auto lg:overflow-x-hidden gap-3"
            >
              <li v-for="plan in service.plans" :key="plan.id">
                <Commerce-Card
                  @click="selectedPlan = plan.id"
                  clickable
                  class="flex shrink-0 items-center gap-4 px-4 py-4 lg:p-4 lg:pe-6 rounded-[14px]! bg-transparent"
                  :class="{ 'border-primary': selectedPlan === plan.id }"
                >
                  <Commerce-Radio :checked="selectedPlan === plan.id" />
                  <div class="font-medium">
                    <div class="font-semibold">{{ plan.name }}</div>
                    <div
                      v-if="plan.starting_price !== null"
                      class="text-sm text-muted-foreground"
                    >
                      {{
                        fx(
                          Number(plan.starting_price),
                          getCurrency(plan.currency),
                        )
                      }}
                    </div>
                    <div v-else class="text-xs text-muted-foreground">
                      مبلغ دلخواه
                    </div>
                  </div>
                </Commerce-Card>
              </li>
            </ul>
            <!-- <template v-if="planPriceOptions.length">
              <h2 class="ms-4 lg:ms-0 text-lg font-bold mt-6">منطقه</h2>
              <div class="mt-2 px-4 lg:px-0 md:w-1/2">
                <Commerce-Select v-model="selectedPlanPriceId" :options="planPriceOptions" />
              </div>
            </template> -->
            <template v-if="planPriceOptions.length">
              <h2 class="ms-4 lg:ms-0 text-lg font-bold mt-6">ریجن</h2>

              <ul
                class="min-w-0 mt-2 flex lg:flex-wrap py-1 px-4 lg:px-0 overflow-x-auto lg:overflow-x-hidden gap-3"
              >
                <li v-for="option in planPriceOptions" :key="option.value">
                  <Commerce-Card
                    clickable
                    class="flex shrink-0 items-center gap-4 px-4 py-4 lg:p-4 lg:pe-6 rounded-[14px]! bg-transparent"
                    :class="{
                      'border-primary': selectedPlanPriceId === option.value,
                    }"
                    @click="selectedPlanPriceId = option.value"
                  >
                    <Commerce-Radio
                      :checked="selectedPlanPriceId === option.value"
                      :show-circle="false"
                    />
                    <div class="font-semibold">
                      {{ option.label }}
                    </div>
                  </Commerce-Card>
                </li>
              </ul>
            </template>

            <h2 class="ms-4 lg:ms-0 text-lg font-bold mt-6">نوع سفارش</h2>
            <div class="mt-2 px-4 lg:px-0 md:w-1/2">
              <Commerce-Select
                v-model="selectedOperation"
                :options="orderTypeOptions"
              />
            </div>

            <!-- TODO -->
            <div
              v-if="selectedPlan === '124234'"
              class="md:w-1/2 px-4 lg:px-0 my-6"
            >
              <Commerce-Field label="مبلغ شارژ API">
                <Commerce-TextField name="email" suffix="$" dir="ltr" />
              </Commerce-Field>
            </div>

            <h2 class="ms-4 lg:ms-0 text-lg font-bold mt-5 lg:mt-6">
              اطلاعات مورد نیاز
            </h2>
            <div
              class="ms-4 lg:ms-0 mt-2 space-y-2 text-xs font-medium text-muted-foreground leading-6"
            >
              <div
                v-if="service.description"
                v-html="service.description"
                class="service-description text-justify leading-7 text-base"
              ></div>
              <p>بعد از ثبت سفارش در صورت نیاز با شما تماس می‌گیریم.</p>
            </div>
            <div class="md:w-1/2 space-y-4 mt-4 px-4 lg:px-0">
              <!-- <Commerce-Field label="ایمیل یا نام کاربری اکانت">
                <Commerce-TextField name="email" placeholder="email@example.com" dir="ltr" />
              </Commerce-Field>
              <Commerce-Field label="رمز عبور اکانت">
                <Commerce-PasswordField name="password" />
              </Commerce-Field> -->

              <Commerce-Field
                v-for="field in service.custom_fields"
                :key="field.id"
                :label="field.label"
              >
                <Commerce-TextField
                  v-if="field.type === 'text' || field.type === 'email'"
                  v-model="customFieldValues[field.name]"
                  :name="field.name"
                  :placeholder="field.placeholder ?? undefined"
                  :type="field.type"
                  dir="ltr"
                />
              </Commerce-Field>

              <!-- <Commerce-Field label="توضیحات سفارش" optional class="">
                <Commerce-TextField v-model="orderNotes" placeholder="توضیحات خود را وارد کنید"  />
              </Commerce-Field> -->
            </div>
          </Commerce-Card>

          <Commerce-Notice
            tone="warning"
            class="mt-6 mx-4 lg:mx-0"
            title="زمان معمول بررسی و انجام سفارش: حداکثر ۲۴ ساعت. این زمان به معنای اجرای فوری یا تضمین قطعی زمان نیست."
          >
          </Commerce-Notice>

          <h2 class="ms-4 lg:ms-0 text-lg font-bold mt-6">
            قوانین و محدودیت‌ها
          </h2>
          <ul
            class="list-disc marker:text-primary px-8 lg:px-0 text-sm text-[#64667D] style mt-4 space-y-2"
          >
            <li>اطلاعات ورود فقط برای انجام همین سفارش استفاده می‌شود.</li>
            <li>سفارش پس از ثبت قابل لغو نیست و پرداخت مرجوعی نیست.</li>
            <li>
              ممکن است هزینه‌هایی مانند VAT یا Service Fee در مرحلهٔ اجرا مشخص
              شوند.
            </li>
          </ul>
        </div>

        <div
          class="fixed bottom-0 start-0 end-0 z-10 border-t border-border lg:border-t-0 shadow-[0_-4px_12px_rgba(0,0,0,0.08)] lg:shadow-none lg:me-6 px-6 lg:px-0 pb-5 lg:pb-0 bg-white lg:bg-transparent self-start lg:sticky transition-[top] duration-500 ease-in-out"
          :class="isScrolled ? 'lg:top-25' : 'lg:top-60'"
        >
          <Commerce-Card class="lg:p-5 border-0 lg:border">
            <div class="mt-4 flex flex-col-reverse lg:flex-col gap-2.5 text-sm">
              <!-- price details  -->
              <div class="flex flex-col gap-2.5">
                <template v-if="ShowPriceDetails">
                  <div class="flex justify-between">
                    <span class="text-card-foreground">مبلغ سرویس</span>
                    <span v-if="selectedPlanPrice !== null" class="font-bold">
                      {{
                        fx(selectedPlanPrice.amount, selectedPlanPrice.currency)
                      }}
                    </span>

                    <span v-else class="text-muted-foreground"> — </span>
                  </div>
                  <div class="flex justify-between">
                    <span class="text-card-foreground">نرخ تبدیل</span>
                    <span v-if="calculator && !loadingCalculator">
                      {{ rial(calculator.exchangeRate) }}
                    </span>
                    <Commerce-Spinner
                      v-else-if="loadingCalculator"
                      :size="16"
                    />
                    <span v-else>—</span>
                  </div>
                  <div class="flex justify-between">
                    <span class="text-card-foreground">کارمزد</span>
                    <span
                      v-if="calculator && !loadingCalculator"
                      class="nums font-bold"
                    >
                      {{ rial(calculator.fee) }}
                    </span>

                    <Commerce-Spinner
                      v-else-if="loadingCalculator"
                      :size="20"
                    />

                    <span v-else class="text-muted-foreground"> — </span>
                  </div>
                  <div class="flex justify-between">
                    <span class="text-card-foreground">ارزش افزوده</span>
                    <span
                      v-if="calculator && !loadingCalculator"
                      class="nums font-bold"
                    >
                      {{ rial(calculator.vat) }}
                    </span>

                    <Commerce-Spinner
                      v-else-if="loadingCalculator"
                      :size="20"
                    />

                    <span v-else class="text-muted-foreground"> — </span>
                  </div>
                </template>
                <div class="flex lg:hidden items-center justify-between">
                  <div class="text-xs text-muted-foreground">
                    مبلغ قطعی پس از ورود با نرخ روز محاسبه می‌شود.
                  </div>
                  <div
                    @click="ShowPriceDetails = !ShowPriceDetails"
                    class="flex items-center gap-4 text-primary"
                  >
                    <span class="text-xs">جزئیات مبلغ</span>
                    <span class="rotate-90 font-bold text-lg">›</span>
                  </div>
                </div>
              </div>
              <!-- payment button -->
              <div
                class="flex flex-row-reverse lg:flex-col items-start lg:items-stretch justify-between gap-2.5"
              >
                <div
                  class="flex flex-col-reverse lg:flex-row items-end lg:items-center justify-start lg:justify-between lg:border-t lg:pt-2.5 border-border"
                >
                  <span
                    class="text-muted-foreground lg:text-card-foreground font-bold"
                    >مبلغ نهایی</span
                  >
                  <span
                    v-if="calculator && !loadingCalculator"
                    class="nums font-bold"
                  >
                    {{ rial(calculator.finalPrice) }}
                  </span>

                  <Commerce-Spinner v-else-if="loadingCalculator" :size="20" />

                  <span v-else class="text-muted-foreground"> — </span>
                </div>

                <Commerce-Button
                  :loading="loadingOrder"
                  size="lg"
                  variant="primary"
                  class="w-32 lg:w-full lg:mt-7 mb-3"
                  @click="createOrder"
                >
                  {{ isLoggedIn ? "پرداخت" : "ورود و پرداخت" }}
                </Commerce-Button>
                <!-- <div class="hidden lg:flex items-center justify-center gap-1.5 text-xs text-muted-foreground">
                  <img src="/public/svg/✓.svg" class="pb-0.5" />
                  ذخیره خودکار اطلاعات سفارش
                </div> -->
              </div>
            </div>
          </Commerce-Card>
        </div>
      </div>
    </div>
    <div v-else-if="loadingService">
      <div class="px-6">
        <div class="skeleton h-4 w-64 max-w-full" />
      </div>

      <div class="mt-6 grid gap-8 lg:grid-cols-[1fr_360px]">
        <!-- Left column -->
        <div class="min-w-0 lg:ps-6">
          <!-- Header -->
          <div class="flex items-start gap-4 px-6 lg:px-0">
            <div class="skeleton h-14 w-14 shrink-0 rounded-2xl" />
            <div class="flex-1 space-y-2 pt-1">
              <div class="skeleton h-7 w-48 max-w-full" />
              <div class="skeleton h-4 w-32 max-w-full" />
            </div>
          </div>

          <!-- Main card -->
          <div
            class="mt-6 rounded-[var(--radius-lg)] border border-[#d8d8d8] bg-white p-4 lg:p-6"
          >
            <div class="space-y-2">
              <div class="skeleton h-4 w-full" />
              <div class="skeleton h-4 w-5/6" />
            </div>

            <div class="skeleton mt-6 h-5 w-28" />
            <div class="mt-3 flex gap-3 overflow-hidden">
              <div
                v-for="i in 3"
                :key="i"
                class="skeleton h-24 w-40 shrink-0 rounded-2xl"
              />
            </div>

            <div class="skeleton mt-6 h-5 w-28" />
            <div class="skeleton mt-3 h-11 w-full rounded-xl md:w-1/2" />

            <div class="skeleton mt-6 h-5 w-36" />
            <div class="mt-3 space-y-2">
              <div class="skeleton h-4 w-full" />
              <div class="skeleton h-4 w-3/4" />
              <div class="skeleton h-4 w-2/3" />
            </div>
          </div>

          <!-- Notice -->
          <div class="skeleton mt-6 h-16 w-full rounded-xl" />

          <!-- Rules -->
          <div class="skeleton mt-6 h-5 w-40" />
          <div class="mt-4 space-y-2 px-4 lg:px-0">
            <div class="skeleton h-4 w-full" />
            <div class="skeleton h-4 w-5/6" />
            <div class="skeleton h-4 w-2/3" />
          </div>
        </div>

        <!-- Right sidebar -->
        <div class="hidden lg:block">
          <div
            class="rounded-[var(--radius-lg)] border border-[#d8d8d8] bg-white p-5"
          >
            <div class="space-y-3">
              <div class="skeleton h-4 w-24" />
              <div class="skeleton h-4 w-32" />
              <div class="skeleton h-4 w-28" />
            </div>
            <div class="mt-6 border-t border-border pt-4">
              <div class="skeleton h-6 w-36" />
            </div>
            <div class="skeleton mt-4 h-12 w-full rounded-xl" />
          </div>
        </div>
      </div>
    </div>
    <div v-else class="py-16">
      <Commerce-EmptyState glyph="⊘" title="سرویس یافت نشد" />
    </div>
  </div>
</template>

<script setup lang="ts">
const siteUrl = useSiteUrl()

import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { useSeoMeta } from '#app'
import { getErrorMessage } from '@/utils/errorUtils'
import { calculatorOrderAction } from '~/api/functions/orders/calculator-order.action'
import { createOrderAction } from '~/api/functions/orders/create-order.action'
import type { CreateOrderPayload, OrderCalculatorResponse, Service } from '~/api/typings'
import { services as fallbackServices } from '~/utils/data'
import { getServiceTypeGlyph } from '~/utils/service-glyphs'
import { fx, rial } from '../utils/format'

const router = useRouter()
const route = useRoute()
const { auth, initAuth } = useAuth()
const { toast } = useToast()
const slug = route.params.slug as string
const selectedPlan = ref<string | null>(null)
const selectedPlanPriceId = ref<string | null>(null)
const selectedOperation = ref<string | null>(null)
const isScrolled = ref(false)
const ShowPriceDetails = ref(true)
const customFieldValues = ref<Record<string, string>>({})
// const orderNotes = ref('')
const calculator = ref<OrderCalculatorResponse | null>(null)
const loadingCalculator = ref(false)
const loadingOrder = ref(false)

const isLoggedIn = computed(() => !!auth.value)

const serviceGlyph = computed(() => {
  return getServiceTypeGlyph(service.value?.categories?.[0]?.slug ?? '')
})

const orderTypeOptions = computed(() => {
  return (
    service.value?.order_types?.map((type) => ({
      value: type.id,
      label: type.name,
    })) ?? []
  )
})

const selectedPlanPrice = computed(() => {
  const plan = service.value?.plans?.find((plan) => plan.id === selectedPlan.value)

  const price = plan?.prices?.[0]

  if (!price) return null

  return {
    amount: Number(price.amount),
    currency: getCurrency(price.currency?.code ?? null),
  }
})

const planPriceOptions = computed(() => {
  const plan = service.value?.plans?.find((plan) => plan.id === selectedPlan.value)
  return (
    plan?.prices
      ?.filter((price) => price.id && price.region)
      .map((price) => ({
        value: price.id,
        label: price.region.name,
      })) ?? []
  )
})

const { service: apiService, loadingService } = useService(slug)

const getCurrency = (currency: string | null): 'USD' | 'EUR' => {
  return currency === 'EUR' ? 'EUR' : 'USD'
}

const service = computed<Service | null>(() => {
  if (apiService.value) return apiService.value as unknown as Service
  // Fallback to static data
  const fallback = fallbackServices.find((s) => s.id === slug)
  return (fallback as unknown as Service) || null
})

const breadcrumbItems = computed(() => {
  const items: { label: string; to?: string }[] = [
    { label: 'خانه', to: 'https://payjib.com' },
    { label: 'همهٔ خدمات', to: '/' },
  ]

  const category = service.value?.categories?.[0]
  if (category?.name && category.slug) {
    items.push({ label: category.name, to: `/category/${category.slug}` })
  }

  if (service.value) {
    items.push({ label: service.value.name })
  }

  return items
})

useSeoMeta({
  title: () => (service.value ? `${service.value.name} - پی‌جیب` : 'خرید سرویس - پی‌جیب'),

  description: () =>
    service.value?.short_description || service.value?.description || 'خرید گیفت کارت و سرویس‌های بین‌المللی از پی‌جیب.',

  robots: 'index,follow',

  ogTitle: () => (service.value ? `${service.value.name} - پی‌جیب` : 'خرید سرویس - پی‌جیب'),

  ogDescription: () =>
    service.value?.short_description || service.value?.description || 'خرید گیفت کارت و سرویس‌های بین‌المللی از پی‌جیب.',

  ogImage: siteUrl('/services/payjib.webp'),
  ogUrl: () => siteUrl(`/services/${slug}`),
  ogType: 'website',
  ogSiteName: 'پی‌جیب',
  ogLocale: 'fa_IR',

  twitterCard: 'summary_large_image',

  twitterTitle: () => (service.value ? `${service.value.name} - پی‌جیب` : 'خرید سرویس - پی‌جیب'),

  twitterDescription: () =>
    service.value?.short_description || service.value?.description || 'خرید گیفت کارت و سرویس‌های بین‌المللی از پی‌جیب.',

  twitterImage: siteUrl('/services/payjib.webp'),
})

const updatePriceDetails = () => {
  ShowPriceDetails.value = window.innerWidth >= 1024
}

async function calculatePrice() {
  if (!service.value || selectedPlan.value === null || !selectedPlanPriceId.value) {
    calculator.value = null
    return
  }

  const plan = service.value.plans.find((plan) => plan.id === selectedPlan.value)

  if (!plan) return

  const price = plan.prices?.find((price) => price.id === selectedPlanPriceId.value)

  if (!price) return

  try {
    loadingCalculator.value = true

    const response = await calculatorOrderAction({
      service_id: service.value.id,
      service_plan_id: plan.id,
      plan_price_id: price.id,
      quantity: 1,
    })

    calculator.value = response.data
  } catch (error) {
    console.error('Failed to calculate order price:', error)
    calculator.value = null
    toast.error(getErrorMessage(error))
  } finally {
    loadingCalculator.value = false
  }
}

async function createOrder() {
  if (!auth.value) {
    router.push({
      path: '/auth',
      query: {
        mode: 'login',
        returnTo: route.fullPath,
      },
    })
    return
  }

  if (
    !service.value ||
    selectedPlan.value === null ||
    selectedOperation.value === null ||
    selectedPlanPriceId.value === null
  )
    return

  const plan = service.value.plans.find((plan) => plan.id === selectedPlan.value)

  if (!plan) return

  const price = plan.prices?.find((price) => price.id === selectedPlanPriceId.value)

  if (!price) return

  const payload: CreateOrderPayload = {
    order_type_id: selectedOperation.value,
    items: [
      {
        service_id: service.value.id,
        service_plan_id: plan.id,
        plan_price_id: price.id,
        quantity: 1,
        custom_fields: customFieldValues.value,
      },
    ],
  }

  try {
    loadingOrder.value = true
    const {
      data: { order },
    } = await createOrderAction(payload)
    await router.push({
      path: `/order/${order.id}`,
    })
  } catch (error) {
    console.error('Failed to create order:', error)
    toast.error(getErrorMessage(error))
  } finally {
    loadingOrder.value = false
  }
}

function handleScroll() {
  isScrolled.value = window.scrollY > 0
}

watch(
  service,
  (newService) => {
    if (!newService) return

    if (newService.plans?.length && !newService.plans.some((plan) => plan.id === selectedPlan.value)) {
      selectedPlan.value = newService.plans[0].id
      selectedPlanPriceId.value = newService.plans[0]?.prices?.[0]?.id
    }

    if (newService.order_types?.length && !newService.order_types.some((type) => type.id === selectedOperation.value)) {
      selectedOperation.value = newService.order_types[0].id
    }
    calculatePrice()
  },
  { immediate: true, deep: true }
)

watch(selectedPlan, () => {
  if (planPriceOptions.value?.length) selectedPlanPriceId.value = planPriceOptions.value[0]?.value ?? null
  else {
    const plan = service.value?.plans?.find((plan) => plan.id === selectedPlan.value)
    if (plan?.prices.length) {
      selectedPlanPriceId.value = plan?.prices.find((x) => !x.region)?.id ?? null
    }
  }

  calculatePrice()
})

onMounted(async () => {
  await initAuth()
  window.addEventListener('scroll', handleScroll, { passive: true })
  updatePriceDetails()
  window.addEventListener('resize', updatePriceDetails)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
  window.removeEventListener('resize', updatePriceDetails)
})
</script>
